import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfiguratorChevron',
  props: {
  open: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;

const openClass = computed(() => (props.open ? 'config-chevron--open' : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: _normalizeClass(['config-chevron', openClass.value]),
    width: "18",
    height: "10",
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M1.35583 0.748535L8.77714 9.13577C8.84045 9.20734 8.93141 9.24832 9.02696 9.24832C9.12251 9.24832 9.21347 9.20734 9.27678 9.13577L16.6988 0.748535",
      "stroke-width": "1.25",
      "stroke-linecap": "round"
    }, null, -1)
  ]), 2))
}
}

})